var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "tr",
    { staticClass: "assets-by-class-table__table-classe" },
    [
      _vm._l(_vm.columns, function(col) {
        return [
          col.cellType === "text" && _vm.isVisible(col.key)
            ? _c("td", {
                key: "cell-" + col.key,
                staticClass: "assets-by-class-table__table-classe-column"
              })
            : col.key === "ativo" && _vm.isVisible("ativo")
            ? _c(
                "td",
                {
                  key: "ativo-" + col.key,
                  staticClass: "assets-by-class-table__table-classe-column"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "assets-by-class-table__table-classe-column--checkbox"
                    },
                    [
                      !_vm.readonly
                        ? _c("v-simple-checkbox", {
                            staticClass: "p-0 m-0",
                            attrs: {
                              dense: "",
                              "hide-details": "",
                              ripple: false,
                              value: _vm.group.selection.isChecked,
                              indeterminate:
                                _vm.group.selection.isIndeterminate,
                              color: "primary"
                            },
                            on: { input: _vm.handleSelectClasse }
                          })
                        : _vm._e(),
                      _c("div", [_vm._v(_vm._s(_vm.name))])
                    ],
                    1
                  )
                ]
              )
            : col.key === "instituicao" && _vm.isVisible("instituicao")
            ? _c("td", {
                key: "inst-" + col.key,
                staticClass: "assets-by-class-table__table-classe-column"
              })
            : col.key === "saldo_valor" && _vm.isVisible("saldo_valor")
            ? _c(
                "td",
                {
                  key: "svalor-" + col.key,
                  staticClass:
                    "assets-by-class-table__table-classe-column assets-by-class-table__table-classe-column--money text-right"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "assets-by-class-table__classe-sum",
                      class: _vm.sumClass
                    },
                    [_vm._v(" " + _vm._s(_vm.group.meta.sumFmt) + " ")]
                  )
                ]
              )
            : col.key === "saldo_pct" && _vm.isVisible("saldo_pct")
            ? _c(
                "td",
                {
                  key: "spct-" + col.key,
                  staticClass:
                    "assets-by-class-table__table-classe-column text-right"
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "assets-by-class-table__classe-pct",
                      class: _vm.sumClass
                    },
                    [_vm._v(" " + _vm._s(_vm.group.meta.pctFmt) + " ")]
                  )
                ]
              )
            : col.key === "saldo_data" && _vm.isVisible("saldo_data")
            ? _c("td", {
                key: "sdata-" + col.key,
                staticClass: "assets-by-class-table__table-classe-column"
              })
            : col.key === "rent_valor"
            ? [
                _vm.showRentability && _vm.isVisible("rent_valor")
                  ? _c(
                      "td",
                      {
                        key: "rvalor-" + col.key,
                        staticClass:
                          "assets-by-class-table__table-classe-column assets-by-class-table__table-classe-column--money text-right"
                      },
                      [
                        _vm.stats
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "assets-by-class-table__classe-rend",
                                class: _vm.rendimentoClass
                              },
                              [_vm._v(" " + _vm._s(_vm.classRendText) + " ")]
                            )
                          : _vm._e()
                      ]
                    )
                  : _vm._e(),
                _vm.showRentability && _vm.isVisible("rent_inicio")
                  ? _c(
                      "td",
                      {
                        key: col.key + "-inicio",
                        staticClass:
                          "assets-by-class-table__table-classe-column text-left"
                      },
                      [
                        _vm.stats
                          ? _c(
                              "v-tooltip",
                              {
                                attrs: { right: "" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "activator",
                                      fn: function(ref) {
                                        var on = ref.on
                                        return [
                                          _c(
                                            "strong",
                                            _vm._g(
                                              { staticClass: "mouse-hover" },
                                              on
                                            ),
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.mapClassRent[_vm.name]
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          )
                                        ]
                                      }
                                    }
                                  ],
                                  null,
                                  true
                                )
                              },
                              [
                                _c(
                                  "span",
                                  [
                                    _vm._l(
                                      _vm.benchmarksByClass[_vm.name] || [],
                                      function(entry, i) {
                                        return _c(
                                          "p",
                                          {
                                            key: entry.benchmark.id || i,
                                            staticClass: "mb-0"
                                          },
                                          [
                                            _vm._v(
                                              " " + _vm._s(entry.text) + " "
                                            )
                                          ]
                                        )
                                      }
                                    ),
                                    _c("p", { staticClass: "mb-0" }, [
                                      _vm._v(" Desde o início: "),
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "assets-by-class-table__classe-inicio"
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.classInicioFmtByName[
                                                  _vm.name
                                                ]
                                              ) +
                                              " "
                                          )
                                        ]
                                      )
                                    ])
                                  ],
                                  2
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  : _vm._e(),
                _vm.showRentability && _vm.isVisible("rent_data")
                  ? _c("td", {
                      key: col.key + "-data",
                      staticClass: "assets-by-class-table__table-classe-column"
                    })
                  : _vm._e()
              ]
            : col.key === "volatilidade" && _vm.isVisible("volatilidade")
            ? _c(
                "td",
                {
                  key: "vol-" + col.key,
                  staticClass:
                    "assets-by-class-table__table-classe-column text-right"
                },
                [
                  _vm.stats
                    ? _c("div", [
                        _c(
                          "span",
                          { staticClass: "assets-by-class-table__classe-vol" },
                          [
                            _vm._v(
                              " " +
                                _vm._s(_vm.classVolFmtByName[_vm.name]) +
                                " "
                            )
                          ]
                        )
                      ])
                    : _vm._e()
                ]
              )
            : col.key === "recomendacao" && _vm.isVisible("recomendacao")
            ? _c("td", {
                key: "rec-" + col.key,
                staticClass: "assets-by-class-table__table-classe-column"
              })
            : col.key === "comentario" && _vm.isVisible("comentario")
            ? _c("td", {
                key: "com-" + col.key,
                staticClass: "assets-by-class-table__table-classe-column"
              })
            : col.key === "acoes" && _vm.showAcoes
            ? _c(
                "td",
                {
                  key: "acoes-" + col.key,
                  staticClass: "assets-by-class-table__table-classe-column"
                },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "d-flex align-items-center justify-content-center"
                    },
                    [
                      _vm.showBenchmarkMenu
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "assets-by-class-table__benchmark-menu"
                            },
                            [
                              _c(
                                "v-menu",
                                {
                                  attrs: { "offset-y": "", left: "" },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "activator",
                                        fn: function(ref) {
                                          var on = ref.on
                                          var attrs = ref.attrs
                                          return [
                                            _c(
                                              "v-btn",
                                              _vm._g(
                                                _vm._b(
                                                  {
                                                    attrs: {
                                                      small: "",
                                                      icon: "",
                                                      ripple: false
                                                    }
                                                  },
                                                  "v-btn",
                                                  attrs,
                                                  false
                                                ),
                                                on
                                              ),
                                              [
                                                _c("icon-svg", {
                                                  attrs: {
                                                    name: "mdi-dots-vertical",
                                                    size: 16,
                                                    color: "#8E8E8E"
                                                  }
                                                })
                                              ],
                                              1
                                            )
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    true
                                  )
                                },
                                [
                                  _c(
                                    "v-list",
                                    { attrs: { dense: "" } },
                                    [
                                      _c(
                                        "v-list-item",
                                        {
                                          on: {
                                            click: _vm.handleOpenSaveBenchmark
                                          }
                                        },
                                        [
                                          _c("v-list-item-title", [
                                            _vm._v("Alterar benchmark padrão")
                                          ])
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }